<!--suppress XmlInvalidId -->
<template>
  <section class="space-y-6">
    <CartOrgCodeForm/>
    <div class="bg-white rounded p-5 shadow-light-2">
      <div class="space-y-6 divide-y divide-neutral-300">
        <header class="flex justify-between items-center">
          <h3 class="font-semibold text-xl text-hurst-light-blue flex justify-between">Summary</h3>
          <p class="text-sm text-hurst-blue font-medium">{{ cart.items.length }} items</p>
        </header>
        <ul class="space-y-4 divide-y divide-neutral-300">
          <li v-for="item in cart.items" class="pt-4 grid grid-cols-12 gap-x-2 text-hurst-blue text-sm font-medium">
            <span class="col-span-8">{{ item.name }}</span>
            <button type="button" @click.prevent="removeProduct(item.sku)">
              <span class="col-span-1 text-black">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
                </svg>
              </span>
            </button>
            <span class="col-span-3 text-right">{{ currency(item.subTotalDue ?? item.discountedPrice) }}</span>
          </li>
        </ul>
        <dl class="pt-2 space-y-2">
          <div class="flex justify-between text-hurst-blue text-sm font-medium">
            <dt>Subtotal</dt>
            <dd>{{ currency(cart.amountOwedByStudentSubTotal ?? cart.subtotal) }}</dd>
          </div>
          <div class="flex justify-between text-hurst-blue text-sm font-medium">
            <dt>Shipping</dt>
            <dd>{{ currency(cart.shippingCost) }}</dd>
          </div>
          <div class="flex justify-between text-hurst-blue text-sm font-medium">
            <dt>Sales Tax</dt>
            <dd>{{ currency(cart.tax) }}</dd>
          </div>
          <div class="flex justify-between text-hurst-blue text-xl font-medium">
            <dt>Total</dt>
            <dd>{{ currency(cart.amountOwedByStudent) }}</dd>
          </div>
        </dl>
      </div>
      <div>
        <cart-button type="submit" form="paymentForm" class="w-full justify-center" :disabled="!canSubmit">
          Submit Order
        </cart-button>
      </div>
    </div>
  </section>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import Swal from 'sweetalert2';
import CartOrgCodeForm from './CartOrgCodeForm';
import CartButton from "./CartButton.vue";

;

const {mapState, mapActions, mapGetters} = createNamespacedHelpers('cart');

export default {
  name: "CartMiniCart",
  components: {CartButton, CartOrgCodeForm},
  props: { currentStep: {type: Number, default: 0} },
  data() {
    return {
      lockCheckoutButton: false
    }
  },

  mounted() {
    this.$root.$on('lockCheckoutButton', data => {
      this.lockCheckoutButton = true;
    });
    this.$root.$on('unlockCheckoutButton', data => {
      this.lockCheckoutButton = false;
    });
  },

  computed: {
    ...mapState({
      cart: state => state.cart,
      paymentType: state => state.paymentType
    }),
    ...mapGetters([
      'canSubmit'
    ])
  },

  watch: {
    'cart': function () {
      if (this.cart.items.length === 0) {
        window.location = '/Cart';
      }
    }
  },

  methods: {
    ...mapActions(['deleteCode', 'deleteProduct']),

    currency(price) {
      return new Intl.NumberFormat("us-en", {style: "currency", currency: "USD"}).format(price);
    },

    removeProduct(sku) {
      Swal.fire({
        icon: 'info',
        title: 'Updating Your Cart',
        html: '<p><i class="fal fa-spinner fa-spin"></i></p>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      });

      this.deleteProduct({sku}).then(() => {
        Swal.close()
      });
    }
  }
}
</script>

<style scoped>

</style>